export default "__VITE_ASSET__DOjYVi38__"